export default __webpack_public_path__ + "static/media/task-yellow.52214f64.svg";